// src/rtkQuery/config/contactApi.config.ts
export const CONTACT_US_ENDPOINTS = {
    SUBMIT: '/contact/contact',
    REQUEST_A_NURSE: '/contact/nurse',
};
